import React, { FC, useState, useEffect } from 'react'
import { IonInput } from '@ionic/react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  tag?: string;
  reject?: () => void;
  resolve?: (val: any) => void;
}

const Tag: FC<IProps> = (props) => {
  const {
    tag,
    reject,
    resolve
  } = props
  const [tagStr, setTagStr] = useState<string>('')
  useEffect(() => {
    setTagStr(tag || '')
  }, [tag])
  return (
    <div className='tag-edit-modal'>
      <div className='tag-input'>
        <IonInput placeholder={i18n.t('location.enterLabel')} value={tagStr} data-cypid='adressEditTagInput' onIonChange={(e: any) => setTagStr(e.detail.value)}></IonInput>
        {
          tag &&
            <div
              className='btn del-btn' data-cypid='adressEditTagDel' onClick={() => resolve && resolve({
                type: 'delete'
              })}
            >
              <span>{i18n.t('common.delete')}</span>
            </div>
        }
        <div
          className='btn sure-btn' data-cypid='adressEditTagConfirm' onClick={() => resolve && resolve({
            type: 'edit',
            tag: tagStr
          })}
        >
          <span>{i18n.t('mkt.common.confirm')}</span>
        </div>
      </div>
    </div>
  )
}

export default observer(Tag)
